// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__eO4ft","links":"footer_links__hgBV-","link":"footer_link__AHfU+","sep":"footer_sep__0wZRM"};